import { render, staticRenderFns } from "./LaserEmitter.vue?vue&type=template&id=847368e0&"
var script = {}
import style0 from "./LaserEmitter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports